export const COLORS = {
  primary: "#F08143",
  secondary: "#373743",
  background: "#ECF1F3",
  accent: "#6BA368",
  lightGreen: "rgba(107, 163, 104, 0.2)",
  lighterBg: "rgba(216, 224, 228, 0.6)",
};
